"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Color = exports.FontWeight = exports.LineHeight = exports.FontSize = exports.TextAlign = exports.TextType = exports.CustomText = void 0;
var react_1 = __importDefault(require("react"));
var TextType;
(function (TextType) {
    TextType["BOLDHEAD"] = "boldhead";
    TextType["HEADING"] = "heading";
    TextType["SUBHEADING"] = "subheading";
    TextType["PARAGRAPH"] = "paragraph";
})(TextType || (TextType = {}));
exports.TextType = TextType;
var TextAlign;
(function (TextAlign) {
    TextAlign["START"] = "start";
    TextAlign["CENTER"] = "center";
    TextAlign["END"] = "end";
})(TextAlign || (TextAlign = {}));
exports.TextAlign = TextAlign;
var FontSize;
(function (FontSize) {
    FontSize["XXXXL"] = "96px";
    FontSize["XXXL"] = "72px";
    FontSize["XXL"] = "48px";
    FontSize["XL"] = "32px";
    FontSize["L"] = "24px";
    FontSize["M"] = "20px";
    FontSize["S"] = "18px";
    FontSize["XS"] = "16px";
    FontSize["XXS"] = "14px";
    FontSize["XXXS"] = "12px";
    FontSize["XXXXS"] = "10px";
})(FontSize || (FontSize = {}));
exports.FontSize = FontSize;
var LineHeight;
(function (LineHeight) {
    LineHeight["XXL"] = "5";
    LineHeight["XL"] = "4";
    LineHeight["L"] = "3";
    LineHeight["M"] = "2.5";
    LineHeight["S"] = "2";
    LineHeight["XS"] = "1.5";
    LineHeight["XXS"] = "1";
})(LineHeight || (LineHeight = {}));
exports.LineHeight = LineHeight;
var FontWeight;
(function (FontWeight) {
    FontWeight["BOLD"] = "800";
    FontWeight["NORMAL"] = "600";
    FontWeight["THIN"] = "400";
})(FontWeight || (FontWeight = {}));
exports.FontWeight = FontWeight;
var Color;
(function (Color) {
    Color["DEFAULT"] = "currentColor";
    Color["PRIMARY"] = "text-primary";
    Color["SECONDARY"] = "text-secondary";
    Color["SUCCESS"] = "text-success";
    Color["WARNING"] = "text-warning";
    Color["DANGER"] = "text-danger";
    Color["INFO"] = "text-info";
    Color["DARK"] = "text-dark";
    Color["LIGHT"] = "text-light";
})(Color || (Color = {}));
exports.Color = Color;
var CustomText = function (_a) {
    var _b;
    var id = _a.id, value = _a.value, _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.style, style = _d === void 0 ? {} : _d, _e = _a.textType, textType = _e === void 0 ? TextType.PARAGRAPH : _e, color = _a.color, textAlign = _a.textAlign, fontSize = _a.fontSize, lineHeight = _a.lineHeight, fontWeight = _a.fontWeight, _f = _a.underline, underline = _f === void 0 ? false : _f, _g = _a.overline, overline = _g === void 0 ? false : _g, _h = _a.linethrough, linethrough = _h === void 0 ? false : _h, _j = _a.italic, italic = _j === void 0 ? false : _j, textAlignClass = _a.textAlignClass, containerClass = _a.containerClass, linkText = _a.linkText;
    var defaultStyles = (_b = {},
        _b[TextType.BOLDHEAD] = {
            fontSize: FontSize.XL,
            lineHeight: LineHeight.S,
            fontWeight: FontWeight.BOLD,
        },
        _b[TextType.HEADING] = {
            fontSize: FontSize.XL,
            lineHeight: LineHeight.S,
            fontWeight: FontWeight.NORMAL,
        },
        _b[TextType.SUBHEADING] = {
            fontSize: FontSize.L,
            lineHeight: LineHeight.XS,
            fontWeight: FontWeight.NORMAL,
        },
        _b[TextType.PARAGRAPH] = {
            fontSize: FontSize.XS,
            lineHeight: LineHeight.XXS,
            fontWeight: FontWeight.THIN,
        },
        _b);
    if (textType == TextType.BOLDHEAD && !color) {
        color = Color.DARK;
    }
    else if (textType == TextType.HEADING && !color) {
        color = Color.DARK;
    }
    else if (textType == TextType.SUBHEADING && !color) {
        color = Color.DARK;
    }
    else if (textType == TextType.PARAGRAPH && !color) {
        color = Color.DEFAULT;
    }
    if (textAlign == TextAlign.START) {
        textAlignClass = "text-start";
    }
    else if (textAlign == TextAlign.CENTER) {
        textAlignClass = "text-center";
    }
    else if (textAlign == TextAlign.END) {
        textAlignClass = "text-end";
    }
    var textDecoration = [
        underline ? "underline" : "",
        overline ? "overline" : "",
        linethrough ? "line-through" : "",
    ]
        .filter(Boolean)
        .join(" ");
    var combinedStyle = __assign(__assign(__assign({}, defaultStyles[textType]), { textAlign: textAlign !== null && textAlign !== void 0 ? textAlign : defaultStyles[textType].textAlign, fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : defaultStyles[textType].fontSize, lineHeight: lineHeight !== null && lineHeight !== void 0 ? lineHeight : defaultStyles[textType].lineHeight, fontWeight: fontWeight !== null && fontWeight !== void 0 ? fontWeight : defaultStyles[textType].fontWeight, textDecoration: textDecoration || undefined, fontStyle: italic ? "italic" : undefined }), style);
    var combinedClassName = "".concat(color, " ").concat(className).trim();
    /**
     * Metindeki düz linkleri `<a>` etiketi ile sarmalar ve HTML olarak render eder.
     */
    var processTextWithLinks = function (text, linkText) {
        if (typeof text !== "string")
            return text;
        // URL regex
        var urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
        // Önce tüm satırları parçala (HTML olarak yazıldıysa çalışsın)
        return text
            .split("\n")
            .map(function (line, lineIndex) {
            // Metin içinde link var mı kontrol et
            var parts = line.split(urlRegex);
            return (react_1.default.createElement("p", { key: lineIndex, style: { margin: "0" } }, parts.map(function (part, index) {
                return urlRegex.test(part) ? (react_1.default.createElement("a", { key: index, href: part.startsWith("http") ? part : "https://".concat(part), target: "_blank", rel: "noopener noreferrer", style: { wordBreak: "break-word", color: "#007bff" } }, linkText || part.replace(/https?:\/\/|www\.|\/$/g, ""))) : (react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: part }, key: index }));
            })));
        });
    };
    return (react_1.default.createElement("div", { className: "".concat(containerClass, " ").concat(textAlignClass) },
        react_1.default.createElement("span", { id: id || "custom-text-".concat(Date.now()), className: "custom-text ".concat(combinedClassName), style: combinedStyle }, processTextWithLinks(value, linkText))));
};
exports.CustomText = CustomText;
exports.default = CustomText;
